export enum HWFeatureFlags {
    Placeholder = 'placeholder',
    MissingMetadataQueue = 'missing-metadata-queue',
    MetadataConfiguration = 'metadata-configuration',
    VmsDescriptions = 'vms-descriptions',
    ContractRequirementIsRequiredDiscrepancyTracking = 'contract-requirement-is-required-discrepancy-tracking',
    RequirementDiscrepancyTrackingMarkAsReviewed = 'requirement-discrepancy-tracking-mark-as-reviewed',
    NovaPendingDocumentsToggleText = 'nova-pending-documents-toggle-text',
    AutogeneratedEnvelopeBanner = 'autogenerated-envelope-banner',
    SendAutogeneratedEsignatureEnvelope = 'send-autogenerated-esignature-envelope',
    NovaDocusignEnvelopeAutosendConfigure = 'nova-docusign-envelope-autosend-configure'
}
